export default "/assets/images/screen-04.94e316b70d4a7619.png";